import styles from './index.module.scss';
import { Link, useParams, useLocation } from 'react-router-dom';
import { useState } from 'react';

import backIcon from '../../assets/icon/arrow.png';
import { PopularGroupList } from '../../component/group';
import { ArticleManager } from '../../objects/article/manager';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { OrderShortType } from '../../types';

const Group = observer(() => {
  const params = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const title = query.get('title'); // 'apple'

  const [articleManager] = useState<ArticleManager>(() => {
    const res = new ArticleManager();
    res.setSorter('sort_num');
    res.setOrder(OrderShortType.Descend);
    res.setFilters({
      category: [params.id],
    });
    res.initList();
    return res;
  });

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/">
          <img src={backIcon} />
        </Link>
        <p>{title}高质量搭子俱乐部</p>
      </div>

      <div className={styles.body}>
        <PopularGroupList
          groups={articleManager.allList}
          hasMore={articleManager.hasMore}
          loadMore={() => articleManager.loadMore()}
        />
      </div>
    </div>
  );
});

export default Group;
